import { ActionIcon, Stack, Text, Tooltip } from "@mantine/core"
import { showNotification } from "@mantine/notifications"
import { IconBellOff, IconBellRinging } from "@tabler/icons-react"
import { useState } from "react"

import { useUpdateUser } from "~/pages/Brand/Suppliers/List/muteRemindersHook.ts"

const MuteBellIcon = () => (
  <Tooltip label="Unmute reminders">
    <IconBellOff size={24} />
  </Tooltip>
)

const UnmuteBellIcon = () => (
  <Tooltip label="Mute reminders">
    <IconBellRinging size={24} />
  </Tooltip>
)

interface MuteBellButtonWrapperProps {
  hasMutedReminders: boolean
  userId: string
}

export const MuteButton = ({
  hasMutedReminders,
  userId,
}: MuteBellButtonWrapperProps) => {
  const [hasMuted, setHasMuted] = useState<boolean>(hasMutedReminders)
  const { mutate: updateUser } = useUpdateUser({
    onSuccess: () => {
      setHasMuted(!hasMuted)
      showNotification({
        color: "green",
        message: hasMuted ? "Reminders unmuted" : "Reminders muted",
      })
    },
  })

  if (userId === undefined) {
    return null
  }

  const onClickHandler = () => {
    updateUser({ id: userId, hasMutedReminders: !hasMuted })
  }

  const bellIcon = hasMuted ? <MuteBellIcon /> : <UnmuteBellIcon />

  return (
    <Stack
      style={{
        height: "auto",
      }}
      justify="flex-start"
      align="center"
      gap={0}
    >
      <ActionIcon onClick={onClickHandler}>{bellIcon}</ActionIcon>
      {
        // Helps CSM find muted users with CTRL+F
        hasMuted ? <Text size="8px">Muted</Text> : null
      }
    </Stack>
  )
}
